'use strict';

window.ERSource = (() => {
  const data=window.ER_DATA;
  function routeLink(href) {
    if(!href||href.startsWith('#')||/^(mailto:|tel:|data:|blob:)/.test(href))return href;
    const url=new URL(href,'https://www.emberrove.com');
    if(!['http:','https:'].includes(url.protocol))return window.ERUrl('/');
    if(!['www.emberrove.com','emberrove.com'].includes(url.hostname))return url.href;
    const currentCollections={
      '/collections/everyday-sunglasses':'rx-outdoor',
      '/collections/biking-sunglasses':'rx-cycling',
      '/collections/fishing-collection':'rx-fishing',
      '/collections/golf-elite':'rx-golf',
      '/collections/active-sunglasses':'rx-hiking',
      '/collections/men-all-styles':'rx-running',
      '/collections/women-all-styles':'rx-cycling',
      '/collections/shield-sunglasses':'rx-cycling',
      '/collections/snow-goggle-frames':'rx-mountaineering',
      '/collections/all':'all-rx'
    };
    if(currentCollections[url.pathname])return window.ERUrl('/collections/'+currentCollections[url.pathname]);
    if(url.pathname==='/')return window.ERUrl('/');
    const product=url.pathname.match(/^\/products\/([^/]+)/);
    if(product&&data.products.some(p=>p.handle===product[1]))return window.ERUrl(url.pathname+url.search);
    if(url.pathname==='/collections/prescription-eyewear')return window.ERUrl('/collections/all-rx');
    if(data.collections.some(c=>'/collections/'+c.slug===url.pathname))return window.ERUrl(url.pathname);
    if(url.pathname.startsWith('/collections/'))return window.ERUrl('/collections/all-rx');
    if(data.pages.some(p=>'/pages/'+p.slug===url.pathname))return window.ERUrl(url.pathname);
    return window.ERUrl(url.pathname+url.search+url.hash);
  }
  function styles(urls, {wait = false} = {}) {
    const wanted = [...new Set(urls || [])];
    const styleKey=href=>{const url=new URL(href,document.baseURI);url.searchParams.delete('v');return url.href;};
    const wantedKeys=wanted.map(styleKey);
    const existing = [...document.querySelectorAll('link[data-original-style]')];
    existing.filter(link=>!wantedKeys.includes(styleKey(link.getAttribute('href')))).forEach(link=>link.remove());
    const anchor=document.querySelector('link[data-er-ui-base]');
    const links = wanted.map(href=>{
      let link=existing.find(item=>styleKey(item.getAttribute('href'))===styleKey(href));
      if(!link){link=document.createElement('link');link.rel='stylesheet';link.href=href;link.dataset.originalStyle='';}
      return link;
    });
    const current=[...document.querySelectorAll('link[data-original-style]')];
    if(current.length!==links.length || current.some((link,index)=>link!==links[index])){
      links.forEach(link=>document.head.insertBefore(link,anchor));
    }
    if(!wait)return;
    return Promise.all(links.map(link=>{
      if(link.sheet)return true;
      return new Promise(resolve=>{
        const finish=loaded=>{clearTimeout(timer);link.removeEventListener('load',loadedStyle);link.removeEventListener('error',failedStyle);resolve(loaded);};
        const loadedStyle=()=>finish(true),failedStyle=()=>finish(false);
        const timer=setTimeout(failedStyle,15000);
        link.addEventListener('load',loadedStyle,{once:true});link.addEventListener('error',failedStyle,{once:true});
      });
    })).then(results=>{if(results.includes(false))throw new Error('Product styles could not be loaded.');});
  }
  function details(html) {
    return (html||'').replace('<details','<details class="accordion source-original"');
  }
  function bind(root,product=null) {
    root.erSourceObservers?.forEach(observer=>observer.disconnect());
    root.erSourceObservers=[];
    root.querySelectorAll('template[data-reference-slide-media]').forEach(template=>{
      template.replaceWith(template.content.cloneNode(true));
    });
    root.querySelectorAll('template[data-review-media]').forEach(template=>{
      template.parentElement.replaceChildren(template.content.cloneNode(true));
    });
    root.querySelectorAll('.source-original a[href]').forEach(link=>{
      const previous=link.getAttribute('href'),next=routeLink(previous);
      const destination=new URL(next.replace(/^#/,''),location.origin);
      const productHandle=['www.emberrove.com','emberrove.com'].includes(destination.hostname)?destination.pathname.match(/\/products\/([^/?#]+)/)?.[1]:null;
      if(productHandle && !(window.ERTheme.products||[]).some(product=>product.handle===productHandle)){
        // Captured home and related-product markup must follow the same native catalog.
        (link.closest('.pdp-related-card,.product-card,.reference-best-card,.reference-series-card,.er-lifestyle__card,.reference-hero-slide')||link).remove();
        return;
      }
      link.setAttribute('href',next.startsWith('#/')?window.ERUrl(next.slice(1)):next);
      if(link.closest('.reference-hero-buttons')){
        if(/cycling/i.test(link.textContent))link.setAttribute('href',window.ERUrl('/collections/rx-cycling'));
        else if(/fishing/i.test(link.textContent))link.setAttribute('href',window.ERUrl('/collections/rx-fishing'));
      }
      const handle=next.match(/\/products\/([^/?#]+)/)?.[1];
      const title=data.productTitles?.[handle];
      const liveProduct=data.products.find(p=>p.handle===handle);
      if(liveProduct){
        const variantId=new URL(next.replace(/^#/,''),location.origin).searchParams.get('variant');
        const variant=liveProduct.variants.find(v=>String(v.id)===variantId)||liveProduct.variants[0];
        if(variantId&&String(variant.id)!==variantId){
          destination.searchParams.set('variant',String(variant.id));
          link.setAttribute('href',window.ERUrl(destination.pathname+destination.search+destination.hash));
          if(link.matches('.reference-best-card')||link.closest('.pdp-related-card,.product-card')){
            link.querySelectorAll('img').forEach(image=>{image.src=variant.image;image.removeAttribute('srcset');});
          }
        }
        const current=link.querySelector('.pdp-recommendation-price-current');
        const compare=link.querySelector('.pdp-recommendation-price-compare');
        if(current)current.textContent=window.ERMoney(variant.price);
        if(compare){compare.textContent=variant.compare_at_price>variant.price?window.ERMoney(variant.compare_at_price):'';compare.hidden=!(variant.compare_at_price>variant.price);}
        const bestPrice=link.querySelector('.reference-best-price');
        if(bestPrice){
          bestPrice.replaceChildren();
          if(variant.compare_at_price>variant.price){const old=document.createElement('del');old.textContent=window.ERMoney(variant.compare_at_price);bestPrice.append(old);}
          const value=document.createElement('span');value.textContent=window.ERMoney(variant.price);bestPrice.append(value);
        }
      }
      if(title){
        const variantId=new URL(link.getAttribute('href').replace(/^#/,''),location.origin).searchParams.get('variant');
        const variant=data.products.find(p=>p.handle===handle)?.variants.find(v=>String(v.id)===variantId);
        const name=link.matches('.reference-best-card')?link.querySelector('.reference-best-name>span:first-child'):link.closest('.pdp-related-card,.product-card')?link.querySelector('h3'):link.querySelector('.reference-series-copy>strong');
        if(name)name.textContent=title;
        const description=link.querySelector('.reference-best-description');
        if(description){description.textContent=title;description.hidden=true;}
        if(link.matches('.reference-best-card'))link.setAttribute('aria-label',title);
        else if(link.hasAttribute('aria-label')){
          const suffix=variant?.frame_title||link.getAttribute('aria-label').split(/ — | · /).slice(1).join(' · ');
          link.setAttribute('aria-label',title+(suffix?' — '+suffix:''));
        }
        link.querySelectorAll('img').forEach(img=>{
          if(link.matches('.reference-best-card'))img.alt=title;
          else if(variant?.frame_title)img.alt=title+' — '+variant.frame_title;
        });
      }
      const labels={'/collections/everyday-sunglasses':'RX Outdoor','/collections/biking-sunglasses':'RX Cycling','/collections/fishing-collection':'RX Fishing','/collections/golf-elite':'RX Golf','/collections/active-sunglasses':'RX Hiking','/collections/men-all-styles':'Shop RX Running','/collections/women-all-styles':'Shop RX Cycling','/collections/aviator-sunglasses':'All RX eyewear','/collections/square-sunglasses':'All RX eyewear','/collections/shield-sunglasses':'RX Cycling','/collections/snow-goggle-frames':'RX Mountaineering'};
      if(labels[previous]){
        const label=link.querySelector('h3,strong,span:not([aria-hidden])');
        if(label)label.textContent=labels[previous];
        else {const text=[...link.childNodes].find(node=>node.nodeType===Node.TEXT_NODE&&node.textContent.trim());if(text)text.textContent=labels[previous]+' ';}
      }
      if(/^https?:/.test(next)){link.target='_blank';link.rel='noopener';}
      else if(previous?.startsWith('#')&&!previous.startsWith('#/')){
        link.addEventListener('click',event=>{
          const target=document.getElementById(previous.slice(1));
          if(target){event.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'});}
        });
      }
    });
    root.querySelectorAll('.source-original img[src]').forEach(image=>{
      const src=image.getAttribute('src');
      if(data.framedAssets?.[src]){image.src=data.framedAssets[src];image.dataset.productFramed='';}
    });
    root.querySelectorAll('.er-card-badge[data-badge-slot="title"]').forEach(badge=>badge.remove());
    if(product){
      root.querySelectorAll('.source-original').forEach(container=>{
        const walker=document.createTreeWalker(container,NodeFilter.SHOW_TEXT);
        let node;
        while(node=walker.nextNode()){
          if(node.parentElement?.closest('script,style,template'))continue;
          if(node.nodeValue.includes(product.model))node.nodeValue=node.nodeValue.replaceAll(product.model,'This frame');
        }
      });
      root.querySelectorAll('.source-original [alt],.source-original [aria-label],.source-original [title]').forEach(element=>{
        for(const attribute of ['alt','aria-label','title']){
          if(!element.hasAttribute(attribute))continue;
          let text=element.getAttribute(attribute);
          data.products.forEach(p=>{text=text.replaceAll(p.model,p.title);});
          element.setAttribute(attribute,text);
        }
      });
    }
    root.querySelectorAll('[data-er-hsa-open]').forEach(button=>button.addEventListener('click',()=>{
      const dialog=document.getElementById(button.getAttribute('aria-controls'));
      if(dialog){dialog.showModal();dialog.querySelector('h2')?.focus();}
    }));
    root.querySelectorAll('[data-er-hsa-close]').forEach(button=>button.addEventListener('click',()=>button.closest('dialog').close()));
    root.querySelectorAll('[data-policy-open]').forEach(button=>button.addEventListener('click',()=>{
      const dialog=document.getElementById(button.getAttribute('aria-controls'));
      const template=document.getElementById('KC0409Policy-'+button.dataset.policyOpen);
      if(!dialog||!template)return;
      const content=dialog.querySelector('.kc0409-policy-body');
      content.replaceChildren(template.content.cloneNode(true));
      dialog.querySelector('h2').textContent=template.dataset.policyTitle||'Policy information';
      content.querySelectorAll('a[href]').forEach(link=>{link.href=routeLink(link.getAttribute('href'));});
      dialog.showModal();
    }));
    root.querySelectorAll('.kc0409-policy-close').forEach(button=>button.addEventListener('click',()=>button.closest('dialog').close()));
    root.querySelectorAll('.source-original dialog').forEach(dialog=>dialog.addEventListener('click',e=>{
      if(e.target!==dialog)return;
      const box=dialog.getBoundingClientRect();
      if(e.clientX<box.left||e.clientX>box.right||e.clientY<box.top||e.clientY>box.bottom)dialog.close();
    }));
    const hero=root.querySelector('.reference-hero');
    if(hero){
      const slides=[...hero.querySelectorAll('.reference-hero-slide')];
      hero.querySelectorAll('[data-reference-dot]').forEach(button=>button.addEventListener('click',()=>{
        slides.forEach((slide,index)=>{const selected=index===Number(button.dataset.referenceDot);slide.classList.toggle('is-active',selected);slide.setAttribute('aria-hidden',String(!selected));});
        hero.querySelectorAll('[data-reference-dot]').forEach(dot=>{const selected=dot===button;dot.classList.toggle('is-active',selected);dot.setAttribute('aria-pressed',String(selected));});
      }));
    }
    root.querySelectorAll('[data-series-tab]').forEach(button=>button.addEventListener('click',()=>{
      const section=button.closest('.reference-series');
      section.querySelectorAll('[data-series-tab]').forEach(tab=>tab.setAttribute('aria-selected',String(tab===button)));
      const panels=[...section.querySelectorAll('.reference-series-grid')];
      panels.forEach((panel,index)=>{panel.hidden=(button.dataset.seriesTab==='best'?index!==0:index!==1);});
    }));
    const rails=[
      ['[data-pdp-posters]','[data-pdp-poster-rail]','[data-pdp-poster-prev]','[data-pdp-poster-next]'],
      ['.pdp-recommendations','[data-pdp-track]','[data-pdp-prev]','[data-pdp-next]'],
      ['.reference-bestsellers','.reference-best-track','[data-carousel-prev]','[data-carousel-next]']
    ];
    rails.forEach(([sectionSelector,railSelector,previousSelector,nextSelector])=>{
      root.querySelectorAll(sectionSelector).forEach(section=>{
        const rail=section.querySelector(railSelector),previous=section.querySelector(previousSelector),next=section.querySelector(nextSelector);
        if(!rail||!previous||!next)return;
        const update=()=>{previous.disabled=rail.scrollLeft<2;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;const controls=section.querySelector('.reference-carousel-controls');if(controls)controls.hidden=rail.scrollWidth<=rail.clientWidth+2;};
        previous.addEventListener('click',()=>rail.scrollBy({left:-rail.clientWidth,behavior:'smooth'}));
        next.addEventListener('click',()=>rail.scrollBy({left:rail.clientWidth,behavior:'smooth'}));
        rail.addEventListener('scroll',update,{passive:true});
        rail.addEventListener('keydown',event=>{
          if(!['ArrowLeft','ArrowRight'].includes(event.key))return;
          event.preventDefault();rail.scrollBy({left:rail.clientWidth*(event.key==='ArrowLeft'?-1:1),behavior:'smooth'});
        });
        requestAnimationFrame(update);
        const resize=new ResizeObserver(update);
        resize.observe(rail);
        if(rail.firstElementChild)resize.observe(rail.firstElementChild);
        root.erSourceObservers.push(resize);
      });
    });
    root.querySelectorAll('[data-scene-comparison]').forEach(container=>{
      const button=container.querySelector('[data-scene-toggle]');
      if(!button)return;
      button.addEventListener('click',()=>{
        const playing=container.classList.toggle('scene-comparison-photo-playing');
        button.setAttribute('aria-pressed',String(playing));
        button.setAttribute('aria-label',playing?'Pause scene comparison':'Play scene comparison');
        button.querySelector('span').textContent=playing?'Ⅱ':'▶';
      });
    });

    root.querySelectorAll('.source-original [data-er-hsa-open]').forEach(button=>button.setAttribute('aria-haspopup','dialog'));
    root.querySelectorAll('.product-card-swatches-more').forEach(button=>button.addEventListener('click',()=>{
      const container=button.closest('.product-card-swatches');
      if(!container)return;
      const expanded=button.getAttribute('aria-expanded')==='true';
      container.querySelectorAll('.product-card-swatch').forEach(link=>{link.hidden=false;link.style.display='inline-flex';});
      button.setAttribute('aria-expanded',String(!expanded));
      button.hidden=true;
    }));
    root.querySelectorAll('[data-footer-toggle]').forEach(button=>button.addEventListener('click',()=>{
      if(!matchMedia('(max-width:760px)').matches)return;
      const target=document.getElementById(button.getAttribute('aria-controls'));
      if(target){target.hidden=!target.hidden;button.setAttribute('aria-expanded',String(!target.hidden));const symbol=button.querySelector('[aria-hidden]');if(symbol)symbol.textContent=target.hidden?'+':'−';}
    }));
    if(root.querySelector('.site-footer')){
      root.erFooterResizeCleanup?.();
      const mobile=matchMedia('(max-width:760px)');
      const layoutFooter=()=>root.querySelectorAll('[data-footer-toggle]').forEach(button=>{
        const target=document.getElementById(button.getAttribute('aria-controls'));
        if(target){target.hidden=mobile.matches;button.tabIndex=mobile.matches?0:-1;button.setAttribute('aria-expanded',String(!mobile.matches));const symbol=button.querySelector('[aria-hidden]');if(symbol)symbol.textContent=mobile.matches?'+':'−';}
      });
      layoutFooter();mobile.addEventListener('change',layoutFooter);
      root.erFooterResizeCleanup=()=>mobile.removeEventListener('change',layoutFooter);
      root.querySelectorAll('[data-country-flag]').forEach(flag=>{
        const code=flag.dataset.countryFlag;
        if(/^[A-Z]{2}$/.test(code))flag.textContent=String.fromCodePoint(...[...code].map(c=>127397+c.charCodeAt(0)));
      });
      const country=root.querySelector('.er-market-country-name');
      if(country&&!country.parentElement.querySelector('.er-market-language')){
        const language=document.createElement('span');language.className='er-market-language';language.textContent=window.ERTheme.language;country.after(language);
      }
      root.querySelectorAll('[data-er-market-close]').forEach(button=>button.addEventListener('click',()=>{button.closest('details').open=false;}));
      root.querySelectorAll('[data-er-country-search]').forEach(input=>input.addEventListener('input',()=>{
        input.closest('.er-market-panel').querySelectorAll('[data-er-country-row]').forEach(row=>{row.hidden=!row.textContent.toLowerCase().includes(input.value.toLowerCase());});
      }));
    }
  }
  window.addEventListener('message',event=>{
    if(event.origin!==location.origin||!event.data?.type?.startsWith('er-review-'))return;
    const frame=[...document.querySelectorAll('iframe.original-review-frame')].find(f=>f.contentWindow===event.source);
    if(!frame)return;
    const product=data.products.find(p=>p.handle===event.data.product);
    if(!product)return;
    if(event.data.type==='er-review-height'&&Number.isFinite(event.data.height)&&event.data.height>=0&&event.data.height<20000)frame.style.height=event.data.height+'px';
    if(event.data.type==='er-review-current-store')window.open(product.source_url+'#customer-reviews','_blank','noopener');
  });
  return {routeLink,styles,details,bind};
})();
